import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    if (!password || !confPassword) {
      setErrorMsg("Please fill in both fields");
      return;
    }
    if (password !== confPassword) {
      setErrorMsg("Passwords do not match");
      return;
    }

    setLoading(true);
    setErrorMsg("");
    setMessage("");

    try {
      const host = process.env.REACT_APP_API_URL || "http://localhost:5000";
      const response = await fetch(`${host}/api/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "Password successfully reset. Redirecting...");
        setTimeout(() => navigate('/login'), 2500); // Redirect to login
      } else {
        setErrorMsg(data.error || "Failed to reset password.");
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Error connecting to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-[#0f0f0f] text-white px-4">
      <div className="w-full max-w-md bg-[#1a1a1a] rounded-2xl shadow-2xl p-8 border border-white/10">
        <h2 className="text-2xl font-bold mb-2">Create New Password</h2>
        <p className="text-sm text-gray-400 mb-6">Enter your new password below.</p>

        <form onSubmit={handleReset} className="flex flex-col gap-4">
          <div>
            <label className="font-semibold text-sm">New Password</label>
            <input
              type="password"
              className="w-full mt-1 p-3 rounded bg-[#111] border border-white/10 outline-none focus:ring-2 focus:ring-yellow-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="font-semibold text-sm">Confirm Password</label>
            <input
              type="password"
              className="w-full mt-1 p-3 rounded bg-[#111] border border-white/10 outline-none focus:ring-2 focus:ring-yellow-400"
              value={confPassword}
              onChange={(e) => setConfPassword(e.target.value)}
            />
          </div>

          {errorMsg && <p className="text-red-400 text-sm mt-1">{errorMsg}</p>}
          {message && <p className="text-green-400 text-sm mt-1">{message}</p>}

          <button
            type="submit"
            disabled={loading}
            className={`bg-yellow-400 text-black p-3 rounded font-bold hover:opacity-90 mt-2 flex justify-center items-center transition-all ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {loading ? <Loader2 className="animate-spin" size={24} /> : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
